import { OrderStatus } from 'src/Redux/artistOrderApi'

const LOCKED_ORDER_STATUSES: readonly OrderStatus[] = [
  OrderStatus.Checkout,
  OrderStatus.CheckoutFailed,
]

export const isOrderLocked = (status?: OrderStatus): boolean =>
  status !== void 0 && LOCKED_ORDER_STATUSES.includes(status)
